/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect,useState } from "react";
import {useNavigate,useParams,useSearchParams,useLocation} from "react-router-dom";
import Cookies from 'universal-cookie';

function Login() {
  const [loginurl, setUrl] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  // const {flag} = useParams();
  // console.log("flag => " + flag);
  
  let code = searchParams.get("code")
  //console.log("code get => "+code);
  let apiUrl = "";
  let apiParams = {};
  const cookies = new Cookies();
  let location = useLocation();

  if (code != null && code !== ""){
    apiUrl = "/Login/CHT";
    apiParams={
      "code":code,
      "date_time":Date.now()
    };
  }else{
    apiUrl = "/Login/AuthInfo";
    apiParams={
      "date_time":Date.now()
    };
  }
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(apiParams)
  };
  useEffect(() => {
   // if (flag === "undefined")
   //   window.location.replace("/");
    if (location.state != null){
     
      cookies.set('redirect_page',location.state.lastPage, { path: '/' });
      cookies.set('redirect_paramObj',location.state.paramObj, { path: '/' });
    }
    fetch("/api"+apiUrl,requestOptions)
        .then(res => res.json())
        .then((result) => {
           // console.log(result);
            if (code == null || code === ""){
              if (/^https:\/\/ibobbyauth\.ai\.hinet\.net/.test(result.authUrl) || /^https:\/\/ibobbyauth-stg\.ai\.hinet\.net/.test(result.authUrl))
                window.location.href=result.authUrl;
              else
                alert("系統維護中請稍候..");
            }
              
            else{
              if (result.isSuccess === 1){
                cookies.set('auth_access_token',result.access_token, { path: '/' });
                cookies.set('auth_token',result.auth_token, { path: '/' });
                cookies.set('auth_refresh_token',result.auth_refresh_token, { path: '/' });
                if (result.access_token != null && result.access_token !== ""){
                  let apiUrl = "";
                  let apiParams = {};
                  apiUrl = "/Login/UserInfo";
                  apiParams={
                      "access_token":result.access_token
                  };
                  const requestOptions = {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(apiParams)
                    };
    
                  // cookie如果存在user會員資料即不再撈取資料
                  if (cookies.get("userInfo") == null){
                      fetch("/api"+apiUrl,requestOptions)
                      .then(res => res.json())
                      .then((result) => {
                          //console.log("user info get => "+ JSON.stringify(result));
                        
                          cookies.set("userInfo",
                              {
                                  "userName":result.result.userName,
                                  "userEmail":result.result.userEmail,
                                  "userPhone":result.result.userPhone,
                                  "userExtraData":result.result.userExtraData,
                                  "chtSn":result.result.chtSn
                              },{ path: '/' })
                          if (cookies.get("redirect_page") !== undefined && cookies.get("redirect_page") != null)
                            navigate(cookies.get("redirect_page"),{state:cookies.get("redirect_paramObj")});
                          else
                            navigate("/");
                      }).catch(err => {
                          throw new Error(err)
                          })
                    }        
              }
               
               // window.location.href="/";
                //navigate('/',{state:{"access_token":result.access_token,"auth_token":result.auth_token,"auth_refresh_token":result.auth_refresh_token }});
              }else{
                navigate('/login',{state:{}});

              }
            }
             // console.log("token get => "+ JSON.stringify(result));
            //setUrl(result.authUrl);   
            
        }).catch(err => {
            throw new Error(err)
        })
  }, [location]);

  return (
    <>
     
    </>
  );
}

export default Login;